import axios from "@/store/axiosInstance";
import { PUBLISHED_LIST_PARAMS } from "@/store/queryDefaults";

const state = {
  wasgeht: [],
  contact: {},
  ueber_uns: [],
  modules: [],
  contents: {}
};

const getters = {
  wasgeht: state => state.wasgeht,
  getPhone: state => state.contact.telefonnummer,
  getMail: state => state.contact.email,
  getAddress: state => state.contact.adresse,
  ueberUns: state => state.ueber_uns,
  modules: state => state.modules,
  contents: state => state.contents
};

const actions = {
  fetchWasGeht({ commit }) {
    axios
      .get("/was-geht", { params: PUBLISHED_LIST_PARAMS })
      .then(res => {
        commit("setWasGeht", res.data.docs);
      })
      .catch(err => {
        console.error(err);
      });
  },
  fetchUeber({ commit }) {
    axios
      .get("/ueber-uns", { params: PUBLISHED_LIST_PARAMS })
      .then(res => {
        commit("setUeber", res.data.docs);
      })
      .catch(err => {
        console.error(err);
      });
  },

  fetchContact({ commit }) {
    axios
      .get("/globals/kontakt")
      .then(res => commit("setContact", res.data))
      .catch(err => console.error(err));
  },
  fetchModules({ commit }) {
    axios
      .get("/module", { params: PUBLISHED_LIST_PARAMS })
      .then(res => commit("setModules", res.data.docs))
      .catch(err => console.error(err));
  },

  fetchContents({ commit }) {
    axios
      .get("/globals/inhalte")
      .then(res => commit("setContents", res.data))
      .catch(err => console.error(err));
  }
};

const mutations = {
  setWasGeht: (state, wasGeht) => (state.wasgeht = wasGeht),
  setContact: (state, contact) => (state.contact = contact),
  setUeber: (state, ueber) => (state.ueber_uns = ueber),
  setModules: (state, modules) => (state.modules = modules),
  setContents: (state, contents) => (state.contents = contents)
};

export default {
  state,
  getters,
  actions,
  mutations
};
